import { render, staticRenderFns } from "./TripartiteVoucherTpl.vue?vue&type=template&id=3544668e&scoped=true"
import script from "./TripartiteVoucherTpl.vue?vue&type=script&lang=js"
export * from "./TripartiteVoucherTpl.vue?vue&type=script&lang=js"
import style0 from "./TripartiteVoucherTpl.vue?vue&type=style&index=0&id=3544668e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3544668e",
  null
  
)

export default component.exports